import React, {Component} from 'react';
import {Card, CardBody, CardImg} from 'reactstrap';
import './Feedback.css'
import frown from '../../assets/images/frown.svg';
import smile from '../../assets/images/smile.svg';
import meh from '../../assets/images/meh.svg';
import {saveResponse, showError} from "../../API/API";
import {Redirect} from "react-router-dom";
import {logPageView} from "../../AppHelpers/GoogleAnalytics";

class Feedback extends Component {
    state = {}

    componentDidMount() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return;
        }
        const {id, deviceName} = this.props.location.state;
        this.setState({id, deviceName});
        setTimeout(() => {
            this.props.history.push("/slider", {deviceName})
        }, 2 * 60 * 1000)
    }

    saveResponseHandler = (response) => {
        this.setState({isLoading: true, response})
        saveResponse(response)
            .then(r => this.props.history.push("/slider", {deviceName: this.state.deviceName}))
            .catch((e) => {
                showError(e)
                this.setState({isLoading: false})
            })
    }

    render() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return <Redirect to="/"/>
        }

        logPageView('/feedback');
        return (
            <div>
                <div style={{backgroundColor: '#74dfef59'}}
                     className="w-100 p-3 d-flex align-items-center justify-content-center blockquote p-2">
                    <div className="header-round-circle round-color mr-2">
                        <i className="fa fa-info"></i>
                    </div>
                    <div>Your signature have been saved of the receipt.</div>
                </div>
                <div className="w-100 blockquote p-2">
                    <Card className="p-3" style={{border: '1px solid', boxShadow: '1px 1px'}}>
                        <span className="text-black mb-4">how was our service?</span>
                    </Card>
                </div>
                <div className="section">
                    <div className="row mt-lg-n3">
                        <div className="col-4 pl-0 pr-0">
                            <Card
                                className={"bg " + (this.state.isLoading && this.state.response === 'Bad' ? 'bg-success' : 'bg-light')}
                                onClick={() => this.saveResponseHandler('Bad')}>
                                <h5 className="text-danger" style={{display: 'flex', justifyContent: 'center'}}
                                    size="lg" block>Bad</h5>
                                <CardImg top width="100%" className='img-feedback img-1' src={frown}
                                         alt="Card image cap"/>
                                <CardBody className="d-flex justify-content-center">
                                </CardBody>
                            </Card>
                        </div>
                        <div className="col-4 pl-0 pr-0">
                            <Card
                                className={"bg " + (this.state.isLoading && this.state.response === 'Neutral' ? 'bg-success' : 'bg-light')}
                                onClick={() => this.saveResponseHandler('Neutral')}>
                                <h5 className="text-warning" style={{display: 'flex', justifyContent: 'center'}}
                                    size="lg" block>Average</h5>
                                <CardImg top width="100%" className='img-feedback' src={meh} alt="Card image cap"/>
                                <CardBody className="d-flex justify-content-center">
                                </CardBody>
                            </Card>
                        </div>
                        <div className="col-4 pl-0 pr-0">
                            <Card
                                className={"bg " + (this.state.isLoading && this.state.response === 'Good' ? 'bg-success' : 'bg-light')}
                                onClick={() => this.saveResponseHandler('Good')}>
                                <h5 className="text-success" style={{display: 'flex', justifyContent: 'center'}}
                                    size="lg" block>Good</h5>
                                <CardImg top width="100%" className='img-feedback' src={smile}
                                         alt="Card image cap"/>
                                <CardBody className="d-flex justify-content-center">

                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Feedback;
